import { SalesforceField } from '../../../../../model/SalesforceField';
import { useMemo, useEffect, useState } from 'react';
import RadioButtonFieldset from 'components/Generic/Forms/FormFields/RadioButtonFieldset';
import { useFormContext } from 'components/Generic/Forms/SalesforceIntegratedForms/FormContext';

const SalesforceConditionalRadioButtons = ({
  formData,
  fields,
  onValueSelected,
  stepName,
}: SalesforceField) => {
  const { updateFormData, updateSummary } = useFormContext();

  const sectionTitle: string =
    fields.isRequired?.value === true ? fields.title.value + '*' : fields.title.value;
  const getDefaultValue = useMemo(() => {
    const defaultValue = fields.items?.find((item) => item.fields.isPreselected?.value);
    return defaultValue?.fields.salesforceValue.value || '';
  }, [fields.items]);

  const [radioButtonsData, setRadioButtonsData] = useState({
    defaultValue: '',
    id: fields.salesforceFieldId.value,
    validations: [],
    optionList: {
      elements:
        fields?.items
          ?.filter((item) => item.template === 'Salesforce Conditional Radio Button')
          .map((item) => {
            return {
              type: 'Option',
              displayName: item.fields?.title?.value,
              value: item.fields.salesforceValue.value,
              fields: item.fields,
            };
          }) || {},
    },
  });

  useEffect(() => {
    // restore user selected value from store
    for (const [key, value] of Object.entries(formData.records[0])) {
      if (key === fields.salesforceFieldId.value) {
        setRadioButtonsData((prevState: any) => ({
          ...prevState,
          defaultValue: value,
        }));
      }
    }

    // set preselectedValue from API data
    if (getDefaultValue) {
      setRadioButtonsData((prevState: any) => ({
        ...prevState,
        defaultValue: getDefaultValue,
      }));
    }
  }, []);

  useEffect(() => {
    if (fields.isRequired?.value === true) {
      setRadioButtonsData((prevState: any) => ({
        ...prevState,
        validations: [
          {
            condition: {
              type: 'IsRequiredCondition',
            },
            message: `Please select ${fields.title.value}`,
          },
        ],
      }));
    }
  }, [
    fields.salesforceFieldId.value,
    fields.isRequired?.value,
    fields.title.value,
    formData.records,
    getDefaultValue,
  ]);

  const onSelect = (value: string): void => {
    onValueSelected(value);
    updateFormData({
      fieldName: fields.salesforceFieldId.value,
      value: value,
    });
    updateSummary({
      stepName: stepName,
      fieldName: {
        storeName: fields.salesforceFieldId.value,
        displayName: fields.title.value,
      },
      fieldValue: value,
    });
  };
  return (
    <div className="mb-4">
      <label className="mb-2 form-label">{sectionTitle}</label>
      {radioButtonsData && (
        <RadioButtonFieldset fields={radioButtonsData} onUpdateValue={onSelect} />
      )}
    </div>
  );
};

export default SalesforceConditionalRadioButtons;
